import { useEffect, useReducer } from 'react'
import { PaymentRequestItem, PaymentRequestParam } from '../../api/paymentOrder'
import { GET_PAYMENT_REQUEST_PAGE } from '../../api/paymentOrder'
import { formatTime, isResponseCodeSuccess } from '../../tools/util'
import reducer, {
  initialState,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationOptionAction,
  setSearchParamAction,
} from './reducer'
import { paymentStatusEnum } from '@/global/enum/invoice'

const useSetupHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { paginationOption, searchParam } = state

  const handlePaginationChange = (page: number, pageSize?: number) => {
    getPageData({
      pageNo: page,
      pageSize: pageSize ? pageSize : paginationOption.pagesize,
    })
  }

  const getPageData = async (params: PaymentRequestParam) => {
    const {
      pageNo = paginationOption.current,
      pageSize = paginationOption.pagesize,
    } = params
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_PAYMENT_REQUEST_PAGE({
      ...params,
    })
    dispatch(setIsTableLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataSourceAction(convertTableState(res.data.content)))
      dispatch(
        setPaginationOptionAction({
          pagesize: pageSize,
          current: pageNo,
          total: res.data.totalCount,
        }),
      )
    }
  }

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParamAction(value))
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...value,
    })
  }

  const handleTableRefresh = () => {
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...searchParam,
    })
  }

  const convertTableState = (list: PaymentRequestItem[]) =>
    list.map((item) => ({
      ...item,
      paymentStatus: paymentStatusEnum.getLabelByValue(
        item.paymentStatus as any,
      ),
      createTime: formatTime(item.createTime),
      paymentPrice: item.paymentPrice ?? '-',
    }))

  useEffect(() => {
    getPageData({
      pageNo: initialState.paginationOption.current,
      pageSize: initialState.paginationOption.pagesize,
    })
    // eslint-disable-next-line
  }, [])

  return {
    state,
    handleTableRefresh,
    handlePaginationChange,
    handleSearchClick,
  }
}
export default useSetupHook
import { useEffect, useReducer } from 'react'
import { PaymentRequestItem, PaymentRequestParam } from '../../api/paymentOrder'
import { GET_PAYMENT_REQUEST_PAGE } from '../../api/paymentOrder'
import { formatTime, isResponseCodeSuccess } from '../../tools/util'
import reducer, {
  initialState,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationOptionAction,
  setSearchParamAction,
} from './reducer'
import { paymentStatusEnum } from '@/global/enum/invoice'

const useSetupHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { paginationOption, searchParam } = state

  const handlePaginationChange = (page: number, pageSize?: number) => {
    getPageData({
      pageNo: page,
      pageSize: pageSize ? pageSize : paginationOption.pagesize,
    })
  }

  const getPageData = async (params: PaymentRequestParam) => {
    const {
      pageNo = paginationOption.current,
      pageSize = paginationOption.pagesize,
    } = params
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_PAYMENT_REQUEST_PAGE({
      ...params,
    })
    dispatch(setIsTableLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataSourceAction(convertTableState(res.data.content)))
      dispatch(
        setPaginationOptionAction({
          pagesize: pageSize,
          current: pageNo,
          total: res.data.totalCount,
        }),
      )
    }
  }

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParamAction(value))
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...value,
    })
  }

  const handleTableRefresh = () => {
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...searchParam,
    })
  }

  const convertTableState = (list: PaymentRequestItem[]) =>
    list.map((item) => ({
      ...item,
      paymentStatus: paymentStatusEnum.getLabelByValue(
        item.paymentStatus as any,
      ),
      createTime: formatTime(item.createTime),
      paymentPrice: item.paymentPrice ?? '-',
    }))

  useEffect(() => {
    getPageData({
      pageNo: initialState.paginationOption.current,
      pageSize: initialState.paginationOption.pagesize,
    })
    // eslint-disable-next-line
  }, [])

  return {
    state,
    handleTableRefresh,
    handlePaginationChange,
    handleSearchClick,
  }
}
export default useSetupHook
